import React, { useState } from "react";

import axios from "axios";
//import exportFromJSON from "export-from-json";
import { write, utils } from "xlsx";
import { saveAs } from "file-saver";

import { ModalWrapper, ModalContainer } from "../Dashboard/Dashboard.style";
import { Header } from "./Modal.style";
import { ButtonWrapper, Button } from "../Dashboard/Dashboard.style";

import { useAuth } from "../../Auth/Auth";

const exportToXLSX = ({ data, fileName }) => {
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `${fileName}.xlsx`);
};

function ExportModal({ setModal, sources, type }) {
  const { readCookie, DisplaySnackbar } = useAuth();
  const [option, setOption] = useState(null);

  const getQuestionOptions = (options) => {
    const qOpts = {
      op1: "Option 1",
      op2: "Option 2",
      op3: "Option 3",
      op4: "Option 4",
    };
    const opts = {
      "Option 1": "",
      "Option 2": "",
      "Option 3": "",
      "Option 4": "",
    };
    options.forEach((option) => {
      const value =
        option.value && option.value.startsWith(`="`)
          ? option.value
          : `="${option.value || ""}"`;
      opts[qOpts[option.optionId]] = value;
    });

    return opts;
  };

  const getCorrectAnswers = (type, answers) => {
    const ANSWER_SEPERATOR = "[BLK]";
    /**
     * mcq:op1
     * mmcq:[op1,op2],
     * oneword:[
     *  {blankId, answer}
     * ],
     * fillup:[
     *  {blankId, answer:"asd"},
     *  {blankId, answer:"Add"}
     * ],
     * correctstatement:op1
     */
    var correctAnswer = null;
    switch (type) {
      case "mcq":
        correctAnswer = answers[type];
        break;
      case "mmcq":
        correctAnswer = answers[type].join(ANSWER_SEPERATOR);
        break;
      case "oneword":
        correctAnswer = answers[type].map((blank) => blank.answer).join(ANSWER_SEPERATOR);
        break;
      case "fillup":
        correctAnswer = answers[type].map((blank) => blank.answer).join(ANSWER_SEPERATOR);
        break;
      case "correctstatement":
        correctAnswer = answers[type];
        break;
      case "descriptive":
        correctAnswer = answers[type].map((blank) => blank.answer).join(ANSWER_SEPERATOR);
        break;
      case "assertion-reasoning":
        correctAnswer = answers[type]?.option || "";
        break;
    }

    return correctAnswer;
  };
  const getQuestionImages = (images) => {
    const extraField = {
      assertImg: "Assertion Image",
      reasonImg: "Reason Image",
    };
    const imageFields = {
      questionImg: "Question Image",
      ...(type === "competency" ? extraField : {}),
      op1: "Option 1 Image",
      op2: "Option 2 Image",
      op3: "Option 3 Image",
      op4: "Option 4 Image",
    };
    const imagesLink = {
      "Question Image": "",
      "Assertion Image": "",
      "Reason Image": "",
      "Option 1 Image": "",
      "Option 2 Image": "",
      "Option 3 Image": "",
      "Option 4 Image": "",
    };

    for (let field in imageFields) {
      const imgField = imageFields[field];
      imagesLink[imgField] = images[field] || "";
    }
    return imagesLink;
  };

  const handleSubmit = async () => {
    if (option === null) {
      DisplaySnackbar("Please choose anyone option", "error");
      return;
    }

    const source = sources[option];
    if (!source) {
      DisplaySnackbar(
        "Something went wrong. Refresh page and try again",
        "error"
      );
      return;
    }

    DisplaySnackbar("Please wait exporting data takes time", "info");
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/v1/${source.api}&export=true`,
      {
        headers: {
          token: `${readCookie("token")}`,
        },
      }
    );

    if (res.data.status !== "success") {
      DisplaySnackbar(res.data.message, "error");
      return;
    }

    exportToXLSX({
      data: res.data.data.questions.map((question) => {
        const questionType = question.questionType;
        const explanation =
          questionType === "assertion-reasoning"
            ? question.correctAnswers[questionType]?.explanation
            : "";

        var obj = {};
        if (type === "competency") {
          obj = {
            Assertion: question.description?.assertion || "",
            Reasoning: question.description?.reasoning || "",

            explanation,
          };
        } else {
          obj = {
            Topic: question.topicId.name,
          };
        }

        return {
          Subject: question.subjectId.name,
          Chapter: question.chapterId.name,
          ...obj,
          Question: question.question,
          "Question Type": questionType,
          Cognitive: question.cognitive,
          Difficulty: question.difficulty,
          ...getQuestionOptions(question.options),
          "Correct Answers": getCorrectAnswers(
            questionType,
            question.correctAnswers
          ),
          ...getQuestionImages(question.images || {}),
          Visibility: question.visibilityStatus,
          QuestionId: question._id,
        };
      }),
      fileName: sources[option].path,
    });
    setModal(false);
  };

  return (
    <ModalWrapper>
      <ModalContainer>
        <Header>
          <h2>Export</h2>
          <h2 onClick={() => setModal(false)} style={{ cursor: "pointer" }}>
            ×
          </h2>
        </Header>
        <p>Choose anyone option to export questions</p>
        <div style={{ margin: "10px 0", display: "flex" }}>
          <input
            type="radio"
            name="export-content"
            onChange={() => setOption(0)}
            style={{ display: "block", margin: "auto 20px auto 0" }}
          />
          <label style={{ fontSize: "1.1rem" }}>
            Export <b>{sources[0].name}</b>
          </label>
        </div>
        {sources[1]?.name && (
          <div style={{ margin: "10px 0", display: "flex" }}>
            <input
              type="radio"
              name="export-content"
              onChange={() => setOption(1)}
              style={{ display: "block", margin: "auto 20px auto 0" }}
            />
            <label style={{ fontSize: "1.1rem" }}>
              Export <b>{sources[1].name}</b>
            </label>
          </div>
        )}
        <ButtonWrapper>
          <Button onClick={() => setModal(false)}>CANCEL</Button>
          <Button onClick={handleSubmit}>Export</Button>
        </ButtonWrapper>
      </ModalContainer>
    </ModalWrapper>
  );
}

export default ExportModal;
